<template>
  <div class="mt-4">
    <v-card class="mx-auto" max-width="95%" elevation="2">
      <v-overlay :value="loadingData" absolute>
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
      </v-overlay>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>[돈만농] 대시보드</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="loadData"><v-icon>mdi-refresh</v-icon></v-btn>
      </v-toolbar>
      <v-card-text class="pa-0">
        <v-list dense>
          <v-list-item class="grey lighten-3">
            <v-list-item-content class="text-center"><strong>[ 유저 정보 ]</strong></v-list-item-content>
          </v-list-item>
          <v-container fluid class="pa-0">
            <v-row no-gutters>
              <v-col cols="12" sm="4">
                <v-card flat color="#E8F5E9" class="ma-1 pa-3">
                  <div class="d-flex justify-space-between"><strong>오늘 신규 가입자</strong><span>{{ formatCoin(info.newby_data || 0) }} 명</span></div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="4">
                <v-card flat color="#E3F2FD" class="ma-1 pa-3">
                  <div class="d-flex justify-space-between"><strong>전체 유저</strong><span>{{ formatCoin(info.total_user_count || 0) }} 명</span></div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="4">
                <v-card flat color="#F3E5F5" class="ma-1 pa-3">
                  <div class="d-flex justify-space-between"><strong>현재 접속자</strong><span>{{ formatCoin(info.access_user_count || 0) }} 명</span></div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <v-list-item class="grey lighten-3">
            <v-list-item-content class="text-center"><strong>[ 보석 정보 ]</strong></v-list-item-content>
          </v-list-item>
          <v-container fluid class="pa-0">
            <v-row no-gutters>
              <v-col cols="12" sm="6">
                <v-card flat color="#E8F5E9" class="ma-1 pa-3">
                  <div class="d-flex justify-space-between"><strong>누적 지급 보석</strong><span>{{ formatCoin(info.gem_total || 0) }}</span></div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6">
                <v-card flat color="#E3F2FD" class="ma-1 pa-3">
                  <div class="d-flex justify-space-between"><strong>현재 보유 보석</strong><span>{{ formatCoin(info.gem_current || 0) }}</span></div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <v-divider/>
          <div style="height:30px"></div>
          <v-list-item class="grey lighten-3">
            <v-list-item-content class="text-center"><strong>[오퍼월 오늘 매출 : {{ formatCoin(totalEarn) }}원]</strong></v-list-item-content>
          </v-list-item>
          <v-divider/>
          <v-container fluid class="pa-0">
            <v-row no-gutters>
              <v-col v-for="p in platforms" :key="p.key" cols="12" sm="6">
                <v-card flat :color="p.color" class="ma-1 pa-3">
                  <div class="d-flex justify-space-between"><strong>{{ p.label }}</strong><span>{{ formatCoin(info[p.key] || 0) }} 원</span></div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <div style="height:30px"></div>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mandoora_dashboard } from '../../api/mandoora';

export default {
  name: 'MandooraDashboard',
  data: () => ({
    loadingData: false,
    info: {},
    platforms: [
      { key: 'tnk', label: 'TNK', color: '#E3F2FD' },
      { key: 'snapplay', label: 'SNAPPLAY', color: '#E8F5E9' },
      { key: 'pincrux_ticket', label: '핀크럭스', color: '#EFEBE9' },
      { key: 'gmo', label: 'GMO', color: '#E8EAF6' },
      { key: 'nstation', label: 'NSTATION', color: '#F3E5F5' },
      { key: 'cpx', label: 'CPX', color: '#E0F7FA' },
      { key: 'maf', label: 'MAF', color: '#FCE4EC' },
      { key: 'dt', label: 'DT', color: '#FFF3E0' },
      { key: 'mallpie', label: '몰파이', color: '#FFF3E0' },
      { key: 'tyrads', label: 'TyrAds', color: '#FFF3E0' },
      { key: 'adjo', label: 'ADJO', color: '#FFF3E0' },
    ],
  }),
  computed: {
    totalEarn() {
      const keys = ['tnk', 'snapplay', 'pincrux_ticket', 'gmo', 'nstation', 'cpx', 'maf', 'dt', 'mallpie', 'tyrads', 'adjo'];
      return keys.reduce((s, k) => s + (Number(this.info[k]) || 0), 0);
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loadingData = true;
      try {
        const body = await mandoora_dashboard.get_dashboard_data();
        const d = body?.response_data?.dashboard_data || body?.dashboard_data || body || {};
        this.info = d;
      } catch (e) {
        console.error('[Mandoora Dashboard]', e);
        alert('대시보드 로드 실패');
      } finally {
        this.loadingData = false;
      }
    },
    formatCoin(v) {
      const n = Number(v);
      return Number.isNaN(n) ? '0' : n.toLocaleString();
    },
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .v-toolbar__content { flex-wrap: wrap; height: auto !important; padding: 8px; gap: 4px; }
}
</style>
